export interface StickyBottomSheetPropConfigSchema {
  baseURL: string | '';
  cartURL: string | '';
}
export class StickyBottomSheetPropConfig {
  private static instance: StickyBottomSheetPropConfig;

  config: StickyBottomSheetPropConfigSchema = {
    baseURL: '',
    cartURL: ''
  };

  private constructor(p_config: StickyBottomSheetPropConfigSchema) {
    this.config = p_config;
  }
  getConfig = () => {
    return this.config;
  };

  getBaseUrl = () => {
    return this.config?.baseURL ?? '';
  };

  getCartUrl = () => {
    return this.config?.cartURL ?? '';
  };

  public static getInstance = (): StickyBottomSheetPropConfig => {
    return StickyBottomSheetPropConfig.instance;
  };
  public static create = (p_config: StickyBottomSheetPropConfigSchema): void => {
    StickyBottomSheetPropConfig.instance = new StickyBottomSheetPropConfig(p_config);
  };
}
